<template>
  <div>
    <div class="row" v-if="isIndex()">
      <el-dialog
        :title="$t('climate.weather_forecast')"
        top="15px"
        width="65%"
        :visible.sync="modals.forecast"
        :close="handleCloseForecast"
        :close-on-click-modal="false"
      >
        <div class="row tac" style="padding: 15px">
          <div class="col-sm-6 col-md-2">
            <div
              class="text-center"
              v-if="currently.currently && Object.keys(currently).length > 0"
            >
              <img
                alt=""
                style="width: 75px"
                v-bind:src="`/static/img/iconos/${currently.currently.icon}.svg`"
              />
              <br />
              <p style="font-family: 'Open Sans', sans-serif">
                {{ currently.currently.summary }}
              </p>
            </div>
            <div class="text-center">
              <p
                class="text-muted"
                style="
                  font-size: 20px;
                  font-family: 'Open Sans', sans-serif;
                  font-weight: bold;
                "
              >
                {{ currentTime }}
              </p>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-10"
            v-if="currently.currently && Object.keys(currently).length > 0"
          >
            <div class="row">
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/temperatura.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.temperature, 1)
                  }}&deg;C</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.temperature') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/humedad.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.humidity * 100, 2)
                  }}%</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.humidity') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/rain.svg" />
                <span style="margin-left: 10px"
                  >{{
                    roundNumber(currently.currently.precipIntensity, 2)
                  }}
                  mm/h</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.precipitation') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/lluvia.svg" />
                <span
                  >{{
                    roundNumber(currently.currently.precipProbability * 100, 2)
                  }}%</span
                >
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.rain_probability') }}</strong></span
                >
              </div>
            </div>
            <hr />
            <br />
            <div class="row other-climate">
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/viento.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.wind') }}:</strong> <br />{{
                    roundNumber(currently.currently.windSpeed * 3.6, 2)
                  }}
                  Km/h
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/barometro.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.pressure') }}:</strong><br />
                  {{ currently.currently.pressure }} mb
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/rocio.svg" />
                <p class="text-muted">
                  <strong style="word-break: auto-phrase"
                    >Punto de Rocío:</strong
                  ><br />
                  {{ currently.currently.dewPoint }}&deg;C
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/cloudy.svg" />
                <p class="text-muted">
                  <strong>Nubes:</strong><br />
                  {{ roundNumber(currently.currently.cloudCover * 100, 2) }}%
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/niebla.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.visibility') }}:</strong><br />
                  {{ roundNumber(currently.currently.visibility, 2) }} Km
                </p>
              </div>
              <div class="col-2 text-center">
                <img alt="" src="/static/img/iconos/ozono.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.ozone') }}:</strong><br />
                  {{ currently.currently.ozone }} U.D.
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_assigned_space') }}
            </h5>
          </div>
        </div>
        <br />
        <br />
        <div
          class="row"
          style="padding: 10px"
          v-if="
            Object.keys(chartOptions).length > 0 &&
            Object.values(chartOptions.xAxis.categories).length
          "
        >
          <div class="col-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_assigned_graph') }}
          </h5>
        </div>
      </el-dialog>
      <div class="col-12">
        <div class="row">
          <div class="col-12 map-climate">
            <div
              ref="map"
              class="map"
              v-if="renderComponent"
              style="height: 800px"
            ></div>
            <div
              id="toolbarDiv"
              class="esri-component esri-widget"
              v-if="renderComponent"
            >
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <br />
      <h5 class="text-muted text-center">
        {{ $t('common_words.no_permissions_assigned_space') }}
      </h5>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import { Chart } from 'highcharts-vue';
import moment from 'moment';
import MixinCharts from 'src/util/mixinCharts';
import MixinNumbers from 'src/util/mixinNumbers';
import { Axios } from 'src/class/Axios.js';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMenu from 'src/util/mixinMenu';
import mixinLocation from 'src/util/mixinLocation';
import { getUrlMasterModule } from 'src/util/Util';

export default {
  components: {
    highcharts: Chart,
  },

  data() {
    return {
      center: {
        lat: 37.774546,
        lng: -122.433523,
      },
      stations: [],
      mapData: {},
      map: null,
      renderComponent: true,
      modals: {
        forecast: false,
      },
      chartOptions: {},
      currently: [],
      currentTime: moment().format('hh:mm:ss'),
    };
  },

  watch: {
    '$i18n.locale': 'loadMap',
  },

  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    MixinCharts,
    MixinNumbers,
    MixinMenu,
    MixinForm,
    mixinLocation,
  ],
  methods: {
    handleCloseForecast() {
      this.modals.forecast = false;
    },

    showForecast() {
      this.$emit('showHideLoading', true);
      this.currently = [];
      this.currentTime = null;
      Axios.getMasters(
        `weatherkitappleapi/getDataApi/${this.map.popup.selectedFeature.attributes.Identificador}`
      ).then((response) => {
        this.modals.forecast = true;
        this.currently = response.data.data;
        this.chartOptions = this.spline(
          'Pron\u00F3stico Clim\u00E1tico',
          'Zona: ' + this.map.popup.selectedFeature.attributes.Estacion,
          this.currently.fullWeek,
          this.currently.serie_bar
        );
        this.currentTime = moment().format('hh:mm:ss');
        this.$emit('showHideLoading');
      });
    },

    async loadMap() {
      await this.getPosition();
      this.renderComponent = false;
      this.$emit('showHideLoading', true);
      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadPointMap(null, this.stations, 7, {
          lat: this.center.lat,
          lng: this.center.lng,
        });
        this.$emit('showHideLoading');
        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 13%;right: 30px;';
        }, 10);
      });
    },
  },

  created() {
    if (this.isIndex()) {
      this.$emit('showHideLoading', true);
      Axios.getMasters('devices/stations/indexfromgis')
        .then((response) => {
          this.stations = response.data.data;
          setTimeout(() => {
            this.loadMap();
          }, 100);
          this.$emit('showHideLoading');
        })
        .catch((error) => {
          this.$emit('showHideLoading');
        });
    }
  },

  mounted() {
    if (getUrlMasterModule() == 'gis') {
      this.selectedItemOnMenu('gis');
    } else {
      this.selectedItemOnMenu(getUrlMasterModule());
    }
  },

  destroyed() {
    if (getUrlMasterModule() == 'gis') {
      this.deselectedItemOnMenu('gis');
    } else {
      this.deselectedItemOnMenu(getUrlMasterModule());
    }
  },
};
</script>
<style lang="scss">
.card-gis-filter .card-body {
  padding: 15px 15px 10px 15px !important;
}

.card-gis-filter > .el-popper[x-placement^='bottom'] {
  margin-top: 38px !important;
}

.card-gis-filter div.el-collapse-item__header {
  padding-left: 10px !important;
}

.card-gis-filter {
  margin-bottom: 0px !important;
}
</style>
